import { ICampaignMetricKey } from '~/modules/campaign-analytics/types';
import { IRMetricKey } from '~/presentation/reports/common/type';
import { IPAMetricKey } from '~/modules/analytics/types';
import { EMetricKey } from '~/types/metric';

const PAGE_METRIC_TO_REPORT: Record<string, IRMetricKey> = {
  [EMetricKey.SESSION]: IRMetricKey.SESSION,
  [EMetricKey.ORDERS]: IRMetricKey.ORDERS,
  [EMetricKey.PAGE_VIEWS]: IRMetricKey.PAGE_VIEWS,
  [EMetricKey.VISITORS]: IRMetricKey.VISITORS,
  [EMetricKey.BOUNCE_RATE]: IRMetricKey.BOUNCE_RATE,
  [EMetricKey.CTR]: IRMetricKey.CTR,
  [EMetricKey.AVG_TIME_ON_PAGE]: IRMetricKey.AVG_TIME_ON_PAGE,
  [EMetricKey.ADDED_TO_CART]: IRMetricKey.ADDED_TO_CART,
  [EMetricKey.ADD_TO_CART_RATE]: IRMetricKey.ADD_TO_CART_RATE,
  [EMetricKey.REACHED_CHECKOUT]: IRMetricKey.REACHED_CHECKOUT,
  [EMetricKey.COMPLETE_CHECKOUT]: IRMetricKey.COMPLETE_CHECKOUT,
  [EMetricKey.CART_ADDITION]: IRMetricKey.CART_ADDITION,
  [EMetricKey.AOV]: IRMetricKey.AOV,
  [EMetricKey.REVENUE]: IRMetricKey.REVENUE,
  [EMetricKey.RPV]: IRMetricKey.RPV,
  [EMetricKey.CONVERSION_RATE]: IRMetricKey.CONVERSION_RATE,
};

const PAGE_BREAKDOWN_TO_REPORT: Record<string, IRMetricKey> = {
  [IPAMetricKey.PAGE_SESSIONS_BY_VISITOR]: IRMetricKey.VISITOR_BY_TYPE,
  [IPAMetricKey.PAGE_SESSIONS_BY_DEVICE]: IRMetricKey.SESSION_BY_DEVICE_TYPE,
  [IPAMetricKey.PAGE_SESSIONS_BY_TRAFFIC]: IRMetricKey.SESSION_BY_TRAFFIC_SOURCE,
};

export const pageAnalyticToReportMetricMap: Record<string, IRMetricKey> = {
  ...PAGE_METRIC_TO_REPORT,
  ...PAGE_BREAKDOWN_TO_REPORT,
};

export const campaignToReportMetricMap: Record<string, IRMetricKey> = {
  [ICampaignMetricKey.SESSION]: IRMetricKey.SESSION,
  [ICampaignMetricKey.ORDER]: IRMetricKey.ORDERS,
  [ICampaignMetricKey.PAGE_VIEWED]: IRMetricKey.PAGE_VIEWS,
  [ICampaignMetricKey.VISITOR]: IRMetricKey.VISITORS,
  [ICampaignMetricKey.BOUNCE_RATE]: IRMetricKey.BOUNCE_RATE,
  [ICampaignMetricKey.CTR]: IRMetricKey.CTR,
  [ICampaignMetricKey.AVG_TIME]: IRMetricKey.AVG_TIME_ON_PAGE,
  [ICampaignMetricKey.ADD_TO_CART]: IRMetricKey.ADDED_TO_CART,
  [ICampaignMetricKey.ADD_TO_CART_RATE]: IRMetricKey.ADD_TO_CART_RATE,
  [ICampaignMetricKey.SESSION_THAT_REACHED_CHECKOUT]: IRMetricKey.REACHED_CHECKOUT,
  [ICampaignMetricKey.SESSION_REACHED_CHECKOUT]: IRMetricKey.REACHED_CHECKOUT,
  [ICampaignMetricKey.SESSION_THAT_COMPLETED_CHECKOUT]: IRMetricKey.COMPLETE_CHECKOUT,
  [ICampaignMetricKey.SESSION_WITH_CART_ADDITION]: IRMetricKey.CART_ADDITION,
  [ICampaignMetricKey.AOV]: IRMetricKey.AOV,
  [ICampaignMetricKey.REVENUE]: IRMetricKey.REVENUE,
  [ICampaignMetricKey.RPV]: IRMetricKey.RPV,
  [ICampaignMetricKey.VISITOR_BY_TYPE]: IRMetricKey.VISITOR_BY_TYPE,
  [ICampaignMetricKey.SESSIONS_BY_DEVICE_TYPE]: IRMetricKey.SESSION_BY_DEVICE_TYPE,
  [ICampaignMetricKey.SESSIONS_BY_TRAFFIC_SOURCE]: IRMetricKey.SESSION_BY_TRAFFIC_SOURCE,
  [ICampaignMetricKey.CONVERSION_RATE]: IRMetricKey.CONVERSION_RATE,
};
